/* eslint-disable react-hooks/exhaustive-deps */
import React,{useState,useContext,useEffect} from 'react'
import { StudentDetailsContext } from '../store/student-details';
import MarksCount from '../utils/MarksCount';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {Modal} from "@mui/material";
import "../styles/ViewStudentMarks.css";
import CloseIcon from '@mui/icons-material/Close';
const ViewStudentMarks = () => {
    const StudentContext = useContext(StudentDetailsContext);
    const[showModal,handleShowModal] = useState(false);
    const[removingStudentDetails,setRemovingStudentDetails] = useState({});
    let examName = "Formative Assessment - 1";

    useEffect(()=>{
        StudentContext.getAllStudentMarks(examName);
    },[]);

    //64ba9f12df5faffc699aabb7
    function removeStudentHandler(examObj){
        StudentContext.removedStudent = false;
        setRemovingStudentDetails(examObj);
        handleShowModal(!showModal);
        console.log("Exam Obj : ",examObj);
    }
    function confirmDeleteMarksHandler(examObj){
        // alert("Your are deleting : "+examObj.name);
        // console.log('you are deleting :',examObj);
    //    removingStudentDetails.students.map((item)=>(alert ('Removing :'+item.AdmissionNumber)))
    // alert("exam id : "+removingStudentDetails._id);
    // console.log('examName',removingStudentDetails.examName);
    // console.log('examName',removingStudentDetails._id);

    StudentContext.deleteExamMarksByAdmission(removingStudentDetails._id);
    StudentContext.getAllStudentMarks(examName);

    }
    return (
    <div className="container mt-5">
    <div className="row mt-5">
    {/* {StudentContext && StudentContext.studentMarksArr.length} */}
    <div className="col-lg-11 deleteModalParent">
    { StudentContext && StudentContext.studentMarksArr.length>0 ?<>
                    {StudentContext  && StudentContext.studentMarksArr &&(
                        <>
                        <table className="table table-bordered table-striped">
        <caption>Student subject wise marks</caption>
            <thead>
                <tr>
                <td>S.No.</td>
                <td>Name</td>
                <td>Admission Id</td>
                <td>Telugu</td>
                <td>Hindi</td>
                <td>English</td>
                <td>Maths</td>
                <td>Physics</td>
                <td>Biology</td>
                <td>Social</td>
                <td>Grand Total</td>
                <td>Actions</td>
                </tr>
            </thead>
            <tbody>
            {StudentContext.studentMarksArr.map((exam)=>(<tr>{
                               <>
                               <td>{StudentContext.studentMarksArr.indexOf(exam)+1}</td>
                              {exam && exam.students.map((item)=>(
                                <td>{item.name}</td>
                              ))}
                              {exam && exam.students.map((item)=>(
                                <td>{item.AdmissionNumber}</td>
                              ))}
                              <td>
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "Telugu" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))    
                              }
                              </td>

                              <td>
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "Hindi" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))
                              }
                              </td>



                              <td>
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "English" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))
                              }
                              </td>


                              <td>
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "Maths" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))
                              }
                              </td>



                              <td>
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "Physics" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))
                              }
                              </td>


                              <td>
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "Biology" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))
                              }
                              </td>




                              <td>  
                              { 
                                exam && exam.students.map((item)=>(
                                <>
                                    {item.subjects && item.subjects.map((subject)=>(
                                        <>{subject.subjectName === "Social" ? subject.optedMarks : null}</>
                                    ))}
                                </>
                              ))
                              }
                              </td>
                              <td>
                              <MarksCount exam = {exam}/>
                              </td>

                              <td>
                                <button className="btn btn-sm btn-danger d-flex flex-row justify-content-center align-items-center"
                                onClick={(e)=>{removeStudentHandler(exam)}}>
                              Remove <DeleteOutlineIcon style={{fontSize:"14px"}}/></button>
                              </td>
                               </>
                                
                                } 


                                </tr>))}


            </tbody>    
        </table>
                               
                        </>
                    )}
                </>:<>
                        <div className='col-lg-12'>
                            <p className='text text-center text-info'>You have removed all the students marks... Upload again to see here</p>
                        </div>
                </>}
        {
            <Modal
            open={showModal}>
                <div className="col-lg-6 card mt-5 deleteModalCard">
                    {StudentContext.removedStudent ? <>
                        <p className="text text-center text-success mb-3">Details removed successfully</p>
                    </> :<>
                    <p className="text text-center mb-3">Are you sure, you want to delete this student marks</p>
                    </>}
                   {StudentContext.removedStudent ? <>
                    <div className="d-flex flex-row justify-content-center">
                        <button className="btn btn-sm btn-warning px-3"
                        onClick={removeStudentHandler}>Close now <CloseIcon style={{fontSize:'15px'}}/></button>
                    </div>
                   </> : <>
                   <div className="d-flex flex-row justify-content-center">
                        <button className="btn btn-sm btn-danger mr-5"
                        onClick={confirmDeleteMarksHandler}>Yes, Delete</button>
                        <button className="btn btn-sm btn-primary"
                        onClick={(e)=>{removeStudentHandler()}}>No, Close!</button>
                    </div>
                   </>}
                </div>
            </Modal>
        }
    </div>
    </div>
    </div>
  )
}

export default ViewStudentMarks